import { isNil } from 'lodash/fp';
import { Component } from 'react';
import { IconName } from '@optimus-web/icons';
import { Dialog } from '../Dialog';
import { TextInput } from '../TextInput';
import { noop } from '../utils/func';
import { StructuredTime, TimeService } from '../utils/services';
import { TimePickerContainerElement, TimePickerDialogWrapperElement } from './style';
import { TimePickerDropdown } from './TimePickerDropdown';

export interface TimeDialogPickerProps<T = StructuredTime> {
    getTimeService: () => TimeService<T>;
    onChange?: (value: string) => void;
    onTimeChange?: (time: T) => void;
    value?: string;
    showSeconds?: boolean;
    className?: string;
    portalContainerId?: string;
    disabled?: boolean;
    accessibleIconLabel?: React.ReactChild;
}

/** @deprecated Use TimePicker as an alternative */
export class TimeDialogPicker<T> extends Component<TimeDialogPickerProps<T>> {
    static defaultProps = {
        onChange: noop,
        onTimeChange: noop,
    };

    containerElement: $TSFixMe;

    constructor(props: $TSFixMe) {
        super(props);

        let value = '';
        if (props.value) {
            ({ value } = props);
        } else if (props.timeValue) {
            // support setting the value from time object for legacy code
            value = props.showSeconds
                ? (this.props as $TSFixMe).getTimeService().getString(props.timeValue)
                : (this.props as $TSFixMe).getTimeService().getShortString(props.timeValue);
        }

        this.state = {
            value,
            opened: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: $TSFixMe) {
        if (nextProps.value !== (this.props as $TSFixMe).value) {
            // shitty angular is shitty angular, it passes nullified values, which would break the component
            const value = isNil(nextProps.value) ? '' : nextProps.value;
            this.setState({ value });
        }
    }

    getTimeFromValue(value: $TSFixMe) {
        const { showSeconds, getTimeService } = this.props;

        let time;
        if (showSeconds) {
            if (getTimeService().isValidString(value)) {
                time = getTimeService().fromString(value);
            }
        } else if (getTimeService().isValidShortString(value)) {
            time = getTimeService().fromShortString(value);
        }

        return time;
    }

    handleTimeChange = (time: $TSFixMe) => {
        const value = (this.props as $TSFixMe).showSeconds
            ? (this.props as $TSFixMe).getTimeService().getString(time)
            : (this.props as $TSFixMe).getTimeService().getShortString(time);
        this.setState({ value });
        (this.props as $TSFixMe).onChange(value);
        (this.props as $TSFixMe).onTimeChange(time);
        this.close();
    };

    handleArrowClick = () => {
        if (!(this.state as $TSFixMe).opened) {
            this.open();
        }
    };

    open() {
        this.setState({ opened: true });
    }

    close = () => {
        this.setState({ opened: false });
    };

    innerRefFunction = (c: $TSFixMe) => {
        this.containerElement = c;
    };

    render() {
        const { className, getTimeService, showSeconds, portalContainerId, onTimeChange, disabled, ...other } =
            this.props;
        // @ts-expect-error $TSFixMeError: Property 'opened' does not exist on type 'Readonly<{}>'.
        const { opened, value } = this.state;

        const time = this.getTimeFromValue(value);

        const containerProps = {
            className,
            ref: this.innerRefFunction,
        };

        const inputProps = {
            ...other,
            value,
            onClick: !disabled ? this.handleArrowClick : null,
            interactiveIconHandler: this.handleArrowClick,
            interactiveIcon: IconName.Time,
            accessibleIconLabel: this.props.accessibleIconLabel,
            disabled,
        };

        const dialogProps = {
            active: opened,
            onClose: this.close,
            actions: [{ children: 'Cancel', onClick: this.close, type: 'submit' as const }],
            portalContainerId,
        };

        const timePickerProps = {
            ...other,
            showSeconds,
            getTimeService,
            onTimeChange: this.handleTimeChange,
            time,
        };

        return (
            <TimePickerContainerElement {...containerProps}>
                {/* @ts-expect-error $TSFixMeError: Property 'name' is missing in type '{ readOnly: boolean; value: any; onClick: (() => void) | null; interactiveIconHandle... */}
                <TextInput {...inputProps} />
                <Dialog {...dialogProps}>
                    <TimePickerDialogWrapperElement>
                        {/* @ts-expect-error $TSFixMeError: Type '{ showSeconds: any; getTimeService: any; onTimeChange: (time: any) => void; time: any; children?: ReactNode; }' is... */}
                        <TimePickerDropdown {...timePickerProps} />
                    </TimePickerDialogWrapperElement>
                </Dialog>
            </TimePickerContainerElement>
        );
    }
}
